module.exports = __webpack_public_path__ + "static/media/search.f6f3a1d4.svg";